import type { ModelKey } from "@/modules/model";
import type { ModelLinkOptions } from "@/modules/model-link";

import { useOrganizationContext } from "@/modules/organization/organization-context";

import { getModelLink } from "./model-link.helper";

export const useModelLink = () => {
  const { contextSlug } = useOrganizationContext();

  const getLink = (
    model: ModelKey,
    { context: customContext, id, search }: ModelLinkOptions = {}
  ) => {
    const context = customContext ?? contextSlug;
    return getModelLink(model, { context, id, search });
  };

  return {
    getModelLink: getLink,
  };
};

export const useModelLinkInline = (
  model: ModelKey,
  options?: ModelLinkOptions
) => {
  const { getModelLink } = useModelLink();

  return getModelLink(model, options);
};
